import { generatePath } from 'react-router-dom'

export const API_METHODS = { POST: 'POST', GET: 'GET', PUT: 'PUT', DELETE: 'DELETE' }

export const routes = {
    index: '/',
    router: '/router/',

    authLogin: '/login/',
    authLogout: '/logout/',
    authRegister: '/register/',
    authCreateUser: '/create-user/',
    authCreateAccount: '/create-account/',
    authPasswordHelp: '/password-help/',
    authPasswordReset: '/password-reset/',
    authHandler: '/auth-handler/',
    privacyPolicy: '/privacy-policy/',
    termsOfUse: '/terms-of-use/',
    invitation: '/invitation/:invitationIds/:checksum/',

    appIndex: '/app/',

    leadsIndex: '/app/leads/',
    leadsView: '/app/leads/:leadId/',

    agentsIndex: '/app/agents/',
    agentsView: '/app/agents/:agentId/',
    agentsCreate: '/app/agents/create/',

    bookingsIndex: '/app/bookings/',
    bookingsView: '/app/bookings/:bookingId/',
    bookingsCreate: '/app/bookings/create/',

    tripsIndex: '/app/trips/',

    commissionsIndex: '/app/commissions/',
    commissionsView: '/app/commissions/:commissionId/',
    commissionsCreate: '/app/commissions/create/',

    adminIndex: '/admin/',

    adminAgentsIndex: '/admin/agents/',
    adminAgentsCreate: '/admin/agents/create/',
    adminAgentsView: '/admin/agents/:agentId/',

    adminBookingsIndex: '/admin/bookings/',

    adminFinanceIndex: '/admin/finance/',
    adminFinanceReceiptsIndex: '/admin/finance/receipts/',
    adminFinanceReceiptsView: '/admin/finance/receipts/:receiptId/',
    adminFinanceReceiptsCreate: '/admin/finance/receipts/create/',

    adminFinancePayoutsIndex: '/admin/finance/payouts/',
    adminFinancePayoutsView: '/admin/finance/payouts/:payoutId/',
    adminFinancePayoutsCreate: '/admin/finance/payouts/create/',

    adminFinanceCommissionsIndex: '/admin/finance/commissions/',

    adminVendorsIndex: '/admin/vendors/',
    adminVendorsView: '/admin/vendors/:vendorId/',
    adminVendorsCreate: '/admin/vendors/create/'
}

export const apiResourceEndpoint = (resource, action, id = null, extraPath = '') => {
    let routeObj = {
        url: `/${resource}/`,
        method: API_METHODS.GET
    }
    // adjust the route
    if (action === 'UPDATE' || action === 'VIEW' || action === 'DELETE') {
        routeObj.url = routeObj.url + `${id}/`
    }
    // adjust the medthod
    if (action === 'CREATE' || action === 'UPDATE') {
        routeObj.method = API_METHODS.POST
    } else if (action === 'DELETE') {
        routeObj.method = API_METHODS.DELETE
    }
    // do we need to append any extra stuff to the url
    if (extraPath !== '') {
        routeObj.url = routeObj.url + extraPath + '/'
    }
    return routeObj
}

export const nestedRoutePath = (parent, route, isParent = false) => {
    let nestedRoute = route.substr(parent.length)
    if (isParent) {
        nestedRoute = nestedRoute + '*'
    }
    return nestedRoute
}

export const buildRoutePath = (route, params = {}) => {
    return generatePath(route, params)
}
